import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
const root = Urls.crmApiUrl //域名
//首页数据请求
const url = {
  getHome: root + "/Intentionclient/home",
  changeIntentionClient: root + "/Intentionclient/changeIntentionClientApi",
  getSource: root + "/Public/getSourceApi",
  getMarketer: root + "/Public/getMarketerApi",
  getIntentCourse: root + "/Public/getIntentCourseApi",
  addIntentionclient: root + "/Intentionclient/addIntentionclientAction",
  checkIntentionClient: root + "/Intentionclient/checkIntentionClientApi",
  getFamilyRelation: root + "/Public/getFamilyRelationApi",
  getFriendRelation: root + "/Public/getFriendRelationApi",
  getClientName: root + "/Client/getClientNameApi",
  bindingClient: root + "/Client/bindingClientAction",
  settingtrackClient: root + "/Client/trackClientAction",
  editClient: root + "/Client/editClientAction",
  delFamilyRelation: root + "/Public/delFamilyRelationApi",
  delIntentionSource: root + "/Public/delIntentionSourceApi",
  getclientOne: root + "/Client/clientOneApi",
  getActivity: root + "/Client/getActivityApi",
  getOrderFieldApi: root + "/Intentionclient/getOrderFieldApi", //获取意向客户排序字段

  conversionCourseApi: root + "/Intentionclient/conversionCourseApi", //意向客户->CRM获取转正课程
  conversionAction: root + "/Intentionclient/conversionAction", //意向客户->CRM转正客户


  dialrecordList: root + "/Client/dialrecordList", //拨打记录管理-wgh
}
const storeCustoMersmanage = {
  //意向客户管理
  getHome(params) {
    return axios.get(url.getHome, {
      params
    })
  },
  //意向客户管理--导出
  getHome1() {
    return url.getHome
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params
    })
  },
  // 获取意向客户排序字段
  getOrderFieldApi(params) {
    return axios.get(url.getOrderFieldApi, {
      params
    })
  },
  // 获取活动名称
  getActivity(params) {
    return axios.get(url.getActivity, {
      params
    })
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, {
      params
    })
  },
  //获取意向课程
  getIntentCourse(params) {
    return axios.get(url.getIntentCourse, {
      params
    })
  },
  // 获取家庭亲属关系
  getFamilyRelation(params) {
    return axios.get(url.getFamilyRelation, {
      params
    })
  },
  // 获取绑定关系
  getFriendRelation(params) {
    return axios.get(url.getFriendRelation, {
      params
    })
  },
  // 绑定学员->获取人员名称
  getClientName(params) {
    return axios.get(url.getClientName, {
      params
    })
  },
  // 招生目标线索->绑定学员
  bindingClient(params) {
    return axios.post(url.bindingClient, qs.stringify(params))
  },
  // 招生目标线索->跟进客户
  settingtrackClient(params) {
    return axios.post(url.settingtrackClient, qs.stringify(params))
  },
  // 获取单个客户的基本信息
  getclientOne(params) {
    return axios.get(url.getclientOne, {
      params
    })
  },
  // 意向客户管理->新增时-检测重名
  checkIntentionClient(params) {
    return axios.get(url.checkIntentionClient, {
      params
    })
  },
  // 意向客户->CRM获取转正课程
  conversionCourseApi(params) {
    return axios.get(url.conversionCourseApi, {
      params
    })
  },
  // 意向客户->CRM转正客户
  conversionAction(params) {
    return axios.post(url.conversionAction, qs.stringify(params))
  },
  // 新增意向客户
  addIntentionclient(params) {
    return axios.post(url.addIntentionclient, qs.stringify(params))
  },
  // 编辑意向客户
  editClient(params) {
    return axios.post(url.editClient, qs.stringify(params))
  },
  // 删除亲属关系
  delFamilyRelation(params) {
    return axios.post(url.delFamilyRelation, qs.stringify(params))
  },
  // 删除意向课程
  delIntentionSource(params) {
    return axios.post(url.delIntentionSource, qs.stringify(params))
  },
  // 转为招生线索或无意向
  changeIntentionClient(params) {
    return axios.post(url.changeIntentionClient, qs.stringify(params))
  },

  dialrecordList(params) {
    return axios.get(url.dialrecordList, {
      params
    })
  },
}

export default storeCustoMersmanage;